import React, { PropsWithChildren } from "react";

import { Sheet, SheetContent } from "@/components/ui/Sheet";

import { getCloseIcon } from "../services/icons";

interface PropsType extends PropsWithChildren {
  show: boolean;
  width?: string;
  barHeight?: "screen";
  topOffset?: number;
  title?: string | React.ReactNode;
  onClose: () => void;
  // footer?: React.ReactNode;
}

export default function SideBar({
  children,
  show,
  title,
  onClose,
  width = "90%",
  topOffset,
}: PropsType) {
  return (
    <Sheet open={show} onOpenChange={onClose}>
      <SheetContent
        style={{
          ...{
            width: width,
            padding: 0,
            outline: "none",
            overflow: "auto",
          },
          ...(topOffset && {
            top: `${topOffset}px`,
            height: `${window.innerHeight - topOffset}px`,
          }),
        }}
        hideClose={true}
        hideBg={true}
      >
        <div className="flex h-full flex-col overflow-hidden">
          <div className="border-b-[1px] border-theme-grey-5 px-7">
            <div className="flex flex-row items-center justify-between text-[20px] font-semibold leading-none text-[#0B0B0B]">
              {title && typeof title === "string" && <div className="py-7">{title}</div>}
              {title && typeof title === "object" && title}
              <div className="cursor-pointer p-1" onClick={onClose}>
                {getCloseIcon("#000000")}
              </div>
            </div>
          </div>
          {children}
        </div>
      </SheetContent>
    </Sheet>
  );
}
